// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__KeeI0","isSelected":"tab_isSelected__F8qrK","list":"tab_list__GaYc_","panel":"tab_panel__oOLC2"};